<template>
  <section class="upload-default">
    <header>
      <div class="flow-btn">
        <button class="alt-btn" @click="previousStep">{{ $t('buttons.cancel') }}</button>
      </div>
      <div class="title">
        <h1>{{ $t('create.defaultTitle') }}:</h1>
      </div>
      <div class="flow-btn">
        <button @click="nextStep" :disabled="!checkedCountry">{{ $t('buttons.continue') }}</button>
      </div>
    </header>
    <div class="toggle-buttons">
      <toggle-button v-model="checkedUS" label="United States"></toggle-button>
      <toggle-button v-model="checkedCA" label="Canada"></toggle-button>
    </div>
  </section>
</template>

<script>
import ToggleButton from '@/components/ToggleButton.vue'

export default {
  name: 'upload-platform',
  components: {
    ToggleButton
  },
  data() {
    return {
      checkedUS: false,
      checkedCA: false
    }
  },
  computed: {
    checkedCountry() {
      return this.checkedUS || this.checkedCA
    }
  },
  methods: {
    previousStep() {
      this.$emit('back')
    },
    nextStep() {
      const path = []
      if (this.checkedUS) path.push('us')
      if (this.checkedCA) path.push('ca')
      path.push('done')
      this.$emit('setState', path)
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-buttons {
  margin: 30px 0 0 -25px;
}
</style>
